// utils/httpForm.js
export function buildMultipartWithJson({ data, files = {} }) {
    const fd = new FormData();

    // Em vez de fd.append("data", JSON.stringify(data))
    // Vamos iterar sobre as chaves do objeto data
    Object.entries(data).forEach(([key, value]) => {
        if (value === null || value === undefined) return;

        // Se for um objeto (como Fabricante ou NCM), envie como string ou id
        if (typeof value === 'object' && !(value instanceof File)) {
            fd.append(key, JSON.stringify(value));
        } else {
            fd.append(key, value);
        }
    });

    // Anexar arquivos (lógica anterior)
    for (const [field, list] of Object.entries(files)) {
        const arr = Array.isArray(list) ? list : [list];
        arr.forEach((f) => {
            if (f instanceof File || f instanceof Blob) fd.append(field, f, f.name);
        });
    }

    return fd;
}
